"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateHemeSamplesFromRowData = exports.hemeGroups = void 0;
require("../helpers/string-exts");
const HemeSampleItem_1 = require("./HemeSampleItem");
/** Groups from sheet data to use as HemeSampleItem type */
var hemeGroups;
(function (hemeGroups) {
    hemeGroups["qc"] = "QCSample";
    hemeGroups["pa"] = "PASample";
    hemeGroups["ma"] = "MASample";
})(hemeGroups = exports.hemeGroups || (exports.hemeGroups = {}));
;
/** Parse row data to create HemeSamples
 * for Groups = QCSample or PA Sample
 * aggregates all subgroups of the sample
 * @data - parsed row data from google sheet
 */
function CreateHemeSamplesFromRowData(data) {
    if (data === null) {
        return [];
    }
    const hemeSamples = [];
    for (const row of data) {
        const group = row.Subgroup;
        // check if group is a valid hemeGroup
        let validGroup = false;
        for (let key in hemeGroups) {
            if (group === hemeGroups[key]) {
                row.Groups = group;
                validGroup = true;
                break;
            }
        }
        if (validGroup) {
            // filter Record<string, string> for each row only if value is not null
            let itemInfo = Object.keys(row)
                .filter(key => row[key] != null && row[key] != undefined && row[key].length > 0)
                .reduce((obj, key) => {
                obj[key.scrub()] = row[key];
                return obj;
            }, {});
            itemInfo['id'] = row.Item.scrub();
            let subgroupsArr = [];
            // get all items in data where groups = row['Item']
            const itemsInGroup = data.filter(item => item.Groups === row.Item);
            // create itemInfo for each subgroup            
            for (const subgroupInfoItem of itemsInGroup) {
                let subgroupInfo = Object.keys(subgroupInfoItem)
                    .filter(key => subgroupInfoItem[key] != null && subgroupInfoItem[key] != undefined && subgroupInfoItem[key].length > 0)
                    .reduce((obj, key) => {
                    obj[key.scrub()] = subgroupInfoItem[key];
                    return obj;
                }, {});
                let subgroupitemId = subgroupInfo['item'].scrub();
                let subgroupRef = subgroupInfo.subgroup.scrub();
                if (subgroupsArr[subgroupRef]) {
                    subgroupsArr[subgroupRef][subgroupitemId] = subgroupInfo;
                }
                else {
                    subgroupsArr[subgroupRef] = {};
                    subgroupsArr[subgroupRef][subgroupitemId] = subgroupInfo;
                }
            }
            itemInfo['subgroups'] = subgroupsArr;
            if (group === hemeGroups.qc) {
                hemeSamples.push(new HemeSampleItem_1.QCSampleItem(itemInfo));
            }
            else {
                hemeSamples.push(new HemeSampleItem_1.HemeSampleItem(itemInfo));
            }
        }
    }
    return hemeSamples;
}
exports.CreateHemeSamplesFromRowData = CreateHemeSamplesFromRowData;
